import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    VerticalFlex,
    Button,
    RadioGroup,
    Input,
    HorizontalFlex,
    PadContainer,
} from 'smartsuite-ui';
import { emailRegex, printOrientation } from '../../shared/constants/constants';
import { useLabelContext } from '../../shared/hooks/labelContext';

function validateEmail(email) {
    return !email?.length
        ? false
        : emailRegex.test(String(email).toLowerCase());
}

export default function EmailModal(props) {
    const { dashboardLabels, exportLabels } = useLabelContext();
    const [recipients, setRecipients] = useState('');
    const [selectedOrientation, setSelectedOrientation] = useState(
        printOrientation.landscape
    );

    const orientationOptions = Object.keys(printOrientation).map(
        (orientation) => ({
            textField: dashboardLabels[orientation],
            valueField: orientation,
        })
    );

    function onSend() {
        props.onSend(recipients, selectedOrientation);
        props.onDismiss();
    }

    return (
        <Modal onOverlayClick={props.onDismiss}>
            <ModalHeader onDismiss={props.onDismiss}>
                {exportLabels.emailHeader}
            </ModalHeader>
            <ModalBody>
                <VerticalFlex>
                    <Input
                        label={exportLabels.recipients}
                        value={recipients}
                        onChange={(event) =>
                            setRecipients(event.target.value || '')
                        }
                        type="email"
                        autoComplete="email"
                        placeholder={exportLabels.emailPlaceHolder}
                    />
                    <PadContainer />
                    <RadioGroup
                        label={`${dashboardLabels.orientation}:`}
                        value={selectedOrientation}
                        options={orientationOptions}
                        onChange={(event) =>
                            setSelectedOrientation(event.target.value)
                        }
                        orientation="vertical"
                    />
                </VerticalFlex>
            </ModalBody>
            <ModalFooter>
                <HorizontalFlex cssClassModifiers={['justify-flex-end']}>
                    <Button
                        disabled={!validateEmail(recipients)}
                        onClick={onSend}
                    >
                        {exportLabels.send}
                    </Button>
                </HorizontalFlex>
            </ModalFooter>
        </Modal>
    );
}

EmailModal.propTypes = {
    onSend: PropTypes.func.isRequired,
    onDismiss: PropTypes.func.isRequired,
};
